import { onError } from '@apollo/client/link/error';
import * as Sentry from '@sentry/react';

export const sentryLink = onError(({ graphQLErrors, networkError, operation }) => {
  // @ts-expect-error DEV is a global
  // eslint-disable-next-line no-undef
  if (typeof __DEV__ !== 'undefined' && __DEV__) {
    if (graphQLErrors) {
      // eslint-disable-next-line no-console
      console.warn('[GraphQL errors]: ', graphQLErrors);
    }
    if (networkError) {
      // eslint-disable-next-line no-console
      console.info('[Network error]: ', networkError);
    }
  } else {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path, extensions }) => {
        if (!extensions?.skipSentry) {
          Sentry.captureException(new Error(`[GraphQL error]: ${message}`), {
            level: 'error',
            extra: {
              locations,
              path,
            },
            contexts: {
              operation: {
                operationName: operation.operationName,
                operationVariables: operation.variables,
                operationType: operation.query ? 'query' : 'mutation',
              },
            },
          });
        }
      });
    }

    if (networkError) {
      // eslint-disable-next-line no-console
      console.info('[Network error]: ', networkError);
    }
  }
});
